export enum RetryStrategy {
    CONSTANT = "constant",
    LINEAR = "linear",
    EXPONENTIAL = "exponential",
}

function calculateDelay(
    attempt: number, 
    initialBackoffMs: number, 
    retryStrategy: RetryStrategy
): number {
    if (retryStrategy === RetryStrategy.CONSTANT) {
        return initialBackoffMs;
    } else if (retryStrategy === RetryStrategy.EXPONENTIAL) {
        return initialBackoffMs * Math.pow(2, attempt); // Exponential backoff
    } else {
        return initialBackoffMs * attempt; // Linear backoff
    }
}

export async function executeWithRetries<T>(
    asyncFunc: () => Promise<T>,
    maxRetries: number = 1,
    initialBackoffMs: number = 1,
    retryStrategy: RetryStrategy = RetryStrategy.CONSTANT
): Promise<T | undefined> {
    let attempt = 1;

    while (attempt <= maxRetries) {
        try {
            return await asyncFunc();
        } catch (error) {
            if (attempt === maxRetries) {
                throw error;
            } else {
                const backoffMilliseconds = calculateDelay(attempt, initialBackoffMs, retryStrategy);
                await new Promise((resolve) => setTimeout(resolve, backoffMilliseconds));
            }

            attempt++;
        }
    }

    return undefined;
}
